export const languages = {
  en: "English",
  ja: "日本語",
};
